import { render, staticRenderFns } from "./PanasViewNew.vue?vue&type=template&id=a420165e&scoped=true&lang=pug&"
import script from "./PanasViewNew.vue?vue&type=script&lang=js&"
export * from "./PanasViewNew.vue?vue&type=script&lang=js&"
import style0 from "./PanasViewNew.vue?vue&type=style&index=0&id=a420165e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a420165e",
  null
  
)

export default component.exports